/*
Copyright (c) 2012-2023 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"
import { FC, useEffect } from "react"
import { Card, Typography, Flex, Button } from "@duxton-web/ui"
import { useTranslationsMap } from "common/utils/i18n"

interface IProps {
  image: string
  title: string
  content: string
  buttonTitle?: string
  onClickSkip?: () => void
  onClickButton?: () => void
  trackPageView?: () => void
}

const ItemPhotoCoverageBanner: FC<IProps> = ({
  image,
  title,
  content,
  buttonTitle = "",
  onClickSkip,
  onClickButton = () => {},
  trackPageView = () => {},
}) => {
  useEffect(() => {
    trackPageView()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClickHandler = () => {
    onClickButton()
  }

  const textMap = useTranslationsMap({
    itemPhotoCoverageBannerSkipButton: "itemPhotoCoverage.banner.skip.button",
  })

  return (
    <Card
      bodyStyle={{ boxShadow: "0px 4px 9px 0px #161a1d0d" }}
      bordered={false}
    >
      <Flex justify="space-between" align="center">
        <Flex gap={24}>
          <img src={image} />
          <Flex vertical justify="center">
            <Typography.Title level={5} style={{ marginBottom: 0 }}>
              {title}
            </Typography.Title>
            <Typography.Text>{content}</Typography.Text>
          </Flex>
        </Flex>
        <Flex gap={12}>
          {!!onClickSkip && (
            <Button
              size="small"
              onClick={onClickSkip}
              data-testid="action-button-skip"
              type="secondary"
            >
              {textMap.itemPhotoCoverageBannerSkipButton}
            </Button>
          )}
          {buttonTitle !== "" && (
            <Button
              size="small"
              onClick={onClickHandler}
              data-testid="action-button"
            >
              {buttonTitle}
            </Button>
          )}
        </Flex>
      </Flex>
    </Card>
  )
}
export default ItemPhotoCoverageBanner
